import * as React from "react";
import styled from "@mui/material/styles/styled";
import { KahunPanelSubGroup } from "shared";
import { findingUsesLevel } from "../useDataInputPanels";
import { LevelValue } from "../../dataInputTypes";
import { QualifiedFeature } from "fe-common/graphql";
import Checkbox from "@mui/material/Checkbox";
import { PanelContext } from "../../../context/diagnosticAgent";
import CircleCheckedFilled from "@mui/icons-material/CheckCircle";
import CircleUnchecked from "@mui/icons-material/RadioButtonUnchecked";
import { clone } from "lodash";

//region [[ Styles ]]
const NormalLabel = styled("span")({
  fontSize: "16px",
  fontWeight: 600,
  cursor: "pointer",
});

const ListItemLevel = styled("div")({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  alignContent: "center",
  margin: "5px",
  height: "32px",
  fontSize: "16px",

  marginLeft: "8px",
  marginRight: "8px",
  paddingLeft: "5px",
  paddingRight: "5px",
});

const AllNormalSection = styled("li")({
  marginBottom: "15px",
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface LevelPanelHeaderProps {
  onMakeNormal: () => void;
  isProcedurePanelAbnormal: (findings: any) => boolean;
  onSelectAbnormal: () => void;
  findings: QualifiedFeature[];
  className?: string;
  getCaseValue: any;
  section: any;
  itemContext: PanelContext;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const LevelPanelHeader = ({ ...props }: LevelPanelHeaderProps) => {
  const isProceduresPanel =
    props.itemContext.panelCategory.id === KahunPanelSubGroup.Procedures &&
    props.itemContext.panel.name !== "Pulmonary Function";

  const isLabPanelAllNormal = () => {
    const levelFindings = props.findings.filter((qf) => findingUsesLevel(qf));
    const positiveNegativeFindings = props.findings.filter(
      (qf) => !findingUsesLevel(qf),
    );
    let panelAllNormal = true;

    if (levelFindings.length > 0) {
      levelFindings.forEach((finding) => {
        const resp = props.getCaseValue(finding, props.section);
        if (!resp || resp.level !== LevelValue.NORMAL) {
          panelAllNormal = false;
        }
      });
    } else if (positiveNegativeFindings.length > 0) {
      positiveNegativeFindings.forEach((finding) => {
        const resp = props.getCaseValue(finding, props.section);
        if (!resp || resp.negate !== true) {
          panelAllNormal = false;
        }
      });
    }
    return panelAllNormal;
  };

  const isProcedurePanelAllNormal = () => {
    const positiveNegativeFindings = props.findings.filter(
      (qf) => !findingUsesLevel(qf),
    );

    let panelAllNormal = false;

    if (positiveNegativeFindings.length > 0) {
      let first = clone(positiveNegativeFindings[0]);
      first.qualifiers = [];
      const resp = props.getCaseValue(first, props.section);
      if (resp && resp.negate === true) {
        panelAllNormal = true;
      }
    }

    return panelAllNormal;
  };

  const checked = isProceduresPanel
    ? isProcedurePanelAllNormal()
    : isLabPanelAllNormal();

  return (
    <AllNormalSection>
      <ListItemLevel>
        <Checkbox
          disableRipple={true}
          color={checked ? "secondary" : "primary"}
          checked={checked}
          className={props.className}
          onChange={props.onMakeNormal}
          icon={<CircleUnchecked />}
          checkedIcon={<CircleCheckedFilled />}
          style={{ padding: "3px", marginLeft: "-17px" }}
        />
        <NormalLabel onClick={props.onMakeNormal}>All Normal</NormalLabel>
      </ListItemLevel>
      {isProceduresPanel && (
        <ListItemLevel style={{ marginTop: "20px", marginLeft: "0px" }}>
          <NormalLabel onClick={props.onSelectAbnormal}>
            Select Abnormal Findings:
          </NormalLabel>
        </ListItemLevel>
      )}
    </AllNormalSection>
  );
};
